(function ($) {
  'use strict';

  /**
   * Main Site Scripts
   * ===
   */


  /**
   * Menu Controls
   */

  $('.js-menu-tray-toggle').menuTrayControls();

  $('.js-contact-tray-toggle').menuTrayControls({
    class_animate_in: 'is-animate-in--from-end',
    class_animate_out: 'is-animate-out--from-end',
  });


  /**
   * Accordion Controls
   */

  $('.js-accordion').each(function () {
    $(this).accordionControls();
  });


  /**
   * Click Thru Links
   */

  $('[data-thru-link]').clickThruLink({
    ignore_els: '.card-menu-item-meta, .card-menu-item-cals, .card-menu-item-cals b',
    selector: '[data-thru-link]',
  });


  /**
   * Download Buttons
   * - download button, arrow button setup
   */

  $('.wp-block-button.download a, .button-outline.download').each(function () {
    $(this).append('<svg class="download-icon-svg" width="23" height="22" aria-hidden="true" focusable="false"><use href="#icon-download" /></svg>');
  });

  $('.wp-block-button.arrow a, .button-outline.arrow').each(function () {
    $(this).append('<svg class="arrow-icon-svg" width="20" height="12" aria-hidden="true" focusable="false"><use href="#icon-arrow" /></svg>');
  });


  /**
   * Hero Down Buttons
   */

  $('.hero-button-down').on('click', function () {
    var $this = $(this);
    var $this_container = $this.closest( '.hero-media-banner' );
    var $next_section = $this_container.next();

    if ( $next_section && $next_section.length ) {
      var offset = $next_section.offset().top - 150;
      $('html, body').animate({ scrollTop: offset }, 300 );
    }
  });


  /**
   * Table of Content Scroll Detection
   */

  var $nav_toc_inner = $('.navigation--toc .toc-body-inner');

  $(window).on('load resize', function () {
    $nav_toc_inner.each(function () {
      var $this = $(this);

      if ( $this.isScrollable() ) {
        $this.addClass( 'is-scrollable' );
      } else {
        $this.removeClass( 'is-scrollable' );
      }
    });
  });


})(jQuery);
